import { FC } from 'react';
import { CatalogMode, AdvertCardList, AdvertType } from '@edikk-edikk/ui';
import { AdvertCardWrapper } from '#advert/components/advert-card/AdvertCardWrapper';
import { useBaseContext } from '#base/hooks/use-base-context';
import { LoadMore } from '#advertList/components/catalog-by-date/LoadMore';
import { useAdvertListContext } from '#advertList/hooks/use-advert-list-context';

const CatalogByDate: FC = () => {
  const { catalogMode } = useBaseContext();
  const { advertDataListByDate } = useAdvertListContext();

  if (catalogMode !== CatalogMode.default) {
    return null;
  }

  const adverts = advertDataListByDate.chunkDataList.flatMap((chunk) => chunk.adverts);

  return (
    <>
      <AdvertCardList
        adverts={adverts}
        renderCard={(advert: AdvertType, index: number) => (
          <AdvertCardWrapper
            key={advert.id}
            index={advertDataListByDate.pagination.totalCount ? index : null}
            advert={advert}
          />
        )}
        total={advertDataListByDate.pagination.totalCount}
      />
      <LoadMore />
    </>
  );
};

export { CatalogByDate };
